// This file added by Bearer Web Developer
function getTime(miliseconds?: number | null, withSeconds = false): string {
    const dateTime = miliseconds ? new Date(miliseconds) : new Date();
    let hours = dateTime.getHours().toString().padStart(2, '0');
    let minutes = dateTime.getMinutes().toString().padStart(2, '0');
    if (withSeconds) {
        let seconds = dateTime.getSeconds().toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    }
    return `${hours}:${minutes}`;
}
export default getTime;